import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-upload-arrow';
export var ID = 'icon-upload-arrow';
/* eslint-disable max-len */

export var SVGUploadArrow = function SVGUploadArrow() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 12 12"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M4,4 L4,6 L2,6 L2,2 L3,2 L13,2 L14,2 L14,6 L12,6 L12,4 L4,4 Z M9,10 L12,10 L8,14 L4,10 L7,10 L7,6 L9,6 L9,10 Z",
    id: "upload-arrow-path"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)"
  }, React.createElement("mask", {
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#upload-arrow-path"
  })), React.createElement("use", {
    fill: "#6D6565",
    transform: "translate(8.000000, 8.000000) scale(1, -1) translate(-8.000000, -8.000000) ",
    xlinkHref: "#upload-arrow-path"
  }))));
};
/* eslint-disable max-len */

var UploadArrow = function UploadArrow(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGUploadArrow
  });
};

UploadArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default UploadArrow;